import { FC, useContext } from 'react';

import { Button, RightUpIcon } from '@smartshell/ui-kit';
import cn from 'classnames';

import { AuthContext } from 'auth';
import { LocalizationContext } from 'localization';

import { FEATURES_CONFIG } from '../config';
import { TFeature } from '../interfaces';
import s from './InfoBlock.module.scss';

interface IInfoBlockProps {
  feature: TFeature;
  absolute?: boolean;
  hideTitle?: boolean;
  centered?: boolean;
  variant?: 'primary' | 'secondary';
}

export const InfoBlock: FC<IInfoBlockProps> = ({
  feature,
  absolute,
  hideTitle,
  centered,
  variant,
}) => {
  const { t, lang } = useContext(LocalizationContext);
  const {
    data: { me },
  } = useContext(AuthContext);

  const isOwner = me?.is_owner;
  const {
    title,
    description = 'feature.unavailable',
    ownerDescription = 'feature.unavailable',
    helpLink,
  } = FEATURES_CONFIG[feature] ?? {};

  return (
    <div
      className={cn(
        s.messageBlock,
        hideTitle && s.hideTitle,
        absolute && s.absolute,
        centered && s.centered,
        variant && s[variant]
      )}
      onClick={() => {
        window.open(isOwner ? 'https://lk.smartshell.gg' : helpLink?.[lang]);
      }}
    >
      {variant !== 'secondary' && (
        <RightUpIcon size="s" className={s.linkView} />
      )}
      <div className={s.message}>
        {!hideTitle && title && <span className={s.header}>{t(title)}</span>}
        {t(isOwner ? ownerDescription : description)}
      </div>
      {variant !== 'secondary' && (
        <Button
          size="s"
          variant="outline"
          iconName={isOwner ? 'LockIcon' : 'InfoIcon'}
          className={s.unlock}
        >
          {t(isOwner ? 'feature.unlock' : 'more')}
        </Button>
      )}
      {variant === 'secondary' && (
        <span className={s.link}>
          {t('feature.footer')}
          <RightUpIcon size="l" className={s.linkView} />
        </span>
      )}
    </div>
  );
};
